import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Editor } from 'slate-react';
import classNames from 'classnames';
import { CloseIcon } from '../../../components/Icons';
import MediaToolbar from '../../LightboxPlugin/components/Toolbar';
import MediaStates from '../../../components/MediaStates';
import TooltipOnHover from '../../../components/TooltipOnHover';
import LazyViewer from './LazyViewer';
import Header from './Header';
import './style.css';

function getNodeWidth(node) {
  return node.data.get('width', 'auto');
}

function getNodeHeight(node) {
  return node.data.get('height', 'auto');
}

function isDataURI(url) {
  return url.startsWith('data:image/');
}

var PDF =
/*#__PURE__*/
function (_Component) {
  _inherits(PDF, _Component);

  function PDF() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PDF);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PDF)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      loadingError: null,
      hoveringDoc: false
    });

    _defineProperty(_assertThisInitialized(_this), "toggleLightbox", function () {
      _this.props.editor.command('openLightbox', _this.props.node);
    });

    _defineProperty(_assertThisInitialized(_this), "onDoubleClick", function () {
      if (_this.props.enableLightbox) {
        _this.toggleLightbox();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onHidePreview", function () {
      var _this$props = _this.props,
          editor = _this$props.editor,
          node = _this$props.node;
      editor.setNodeByKey(node.key, {
        data: _objectSpread({}, node.data.toJS(), {
          preview: false
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onShowPreview", function () {
      var _this$props2 = _this.props,
          editor = _this$props2.editor,
          node = _this$props2.node;
      editor.setNodeByKey(node.key, {
        data: _objectSpread({}, node.data.toJS(), {
          preview: true
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderStates", function (_ref) {
      var loading = _ref.loading,
          error = _ref.error;
      var _this$props3 = _this.props,
          node = _this$props3.node,
          isFocused = _this$props3.isFocused,
          editor = _this$props3.editor,
          enableLightbox = _this$props3.enableLightbox;
      var width = getNodeWidth(node);
      var height = getNodeHeight(node);
      var url = node.data.get('url');
      return React.createElement(MediaStates, {
        isFocused: isFocused,
        loading: loading,
        mediaType: 'file',
        error: error,
        wrapperStyle: {
          minHeight: 124,
          minWidth: error ? 384 : 300,
          maxHeight: error ? 124 : null,
          width: width,
          height: height
        },
        wrapperClassNames: 'image-block line-height-larger width-full height-full'
      }, React.createElement(MediaToolbar, {
        blockKey: node.key,
        url: url,
        toggleLightbox: _this.toggleLightbox,
        readOnly: _this.props.editor.readOnly,
        enableLightbox: enableLightbox,
        onDownload: _this.props.onDownload,
        onRemove: function onRemove() {
          editor.removeNodeByKey(node.key);
        },
        error: error
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "onPdfLoadError", function () {
      _this.setState({
        loadingError: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function () {
      _this.setState({
        hoveringDoc: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function () {
      _this.setState({
        hoveringDoc: false
      });
    });

    return _this;
  }

  _createClass(PDF, [{
    key: "render",
    value: function render() {
      if (!this.props.node) {
        return false;
      }

      var _this$props4 = this.props,
          node = _this$props4.node,
          enableLightbox = _this$props4.enableLightbox,
          editor = _this$props4.editor,
          style = _this$props4.style,
          parent = _this$props4.parent,
          onDownload = _this$props4.onDownload,
          onRemove = _this$props4.onRemove,
          onResize = _this$props4.onResize,
          isSelected = _this$props4.isSelected,
          isFocused = _this$props4.isFocused,
          attributes = _this$props4.attributes,
          isMobile = _this$props4.isMobile,
          elementProps = _objectWithoutProperties(_this$props4, ["node", "enableLightbox", "editor", "style", "parent", "onDownload", "onRemove", "onResize", "isSelected", "isFocused", "attributes", "isMobile"]);

      var url = node.data.get('url');
      var hidePreview = node.data.get('preview') === false || isMobile;
      var width = getNodeWidth(node);
      var imageStyle = style || {
        width: width
      };
      var loading = node.data.get('loading');
      var name = node.data.get('name');

      var _node$data$get = node.data.get('meta'),
          size = _node$data$get.size;

      var error = node.data.get('error') || this.state.loadingError;
      var displayPdf = !loading && (!error || isDataURI(url));
      return displayPdf ? React.createElement("div", Object.assign({}, attributes, elementProps, {
        style: imageStyle,
        className: classNames('radius-normal border-small margin-bottom-small', isSelected ? 'border-primary' : 'border-shade-40')
      }), React.createElement(Header, {
        name: name,
        size: size,
        url: url,
        onShowPreview: this.onShowPreview,
        toggleLightbox: this.toggleLightbox,
        onDelete: function onDelete() {
          return editor.removeNodeByKey(node.key);
        },
        hidePreview: hidePreview,
        isMobile: isMobile,
        readOnly: editor.readOnly
      }), !hidePreview && React.createElement("div", {
        style: {
          width: 'inherit',
          height: 600,
          maxWidth: '100%'
        },
        className: "position-relative overflow-hidden width-full border-top-small border-shade-40",
        onDoubleClick: this.onDoubleClick,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave
      }, React.createElement(LazyViewer, {
        url: url,
        initialScale: 0.75,
        onError: this.onPdfLoadError
      }), this.state.hoveringDoc && !editor.readOnly && React.createElement(TooltipOnHover, {
        placement: "bottom",
        tooltipContent: 'Remove preview',
        withArrow: false
      }, React.createElement("div", {
        className: "media-toolbar position-absolute flexbox flexbox-centered background-shade-50-on-hover radius-normal padding-smaller pointer shade-20 shade-10-on-hover",
        style: {
          right: 24,
          top: 24
        },
        onClick: this.onHidePreview
      }, React.createElement(CloseIcon, {
        size: 16
      }))))) : this.renderStates({
        loading: loading,
        error: error
      });
    }
  }]);

  return PDF;
}(Component);

_defineProperty(PDF, "propTypes", {
  enableLightbox: PropTypes.bool,
  node: PropTypes.object,
  editor: PropTypes.instanceOf(Editor),
  parent: PropTypes.object,
  getUser: PropTypes.func,
  style: PropTypes.object,
  onDownload: PropTypes.func,
  onRemove: PropTypes.func,
  onResize: PropTypes.func,
  isSelected: PropTypes.bool,
  isFocused: PropTypes.bool,
  attributes: PropTypes.object,
  isMobile: PropTypes.bool
});

export default PDF;